import { SnowplowService } from 'wanderu-service-analytics';

function ctaSelected({ name, url }) {
    SnowplowService.fireStructuredEvent({
        action: 'click',
        category: 'shuttle_guide',
        label: 'website_cta_selected',
        property: JSON.stringify({
            name,
            url,
        }),
    });
}

const events = {
    ctaSelected,
};

export default events;
